import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/components/Layout/Main'
import AdminLayout from '@/components/Layout/Admin'

import ShiftIndex from '@/components/Shift/Index'
import ShiftPlanIndex from '@/components/ShiftPlan/Index'
import ShiftSummary from '@/components/Shift/Summary'

import Login from '@/components/Account/Login'
import Index from '@/components/Index'
import Dashboard from '@/components/Dashboard/Index'
import NotFound from '@/components/404'

import adminRoutes from './admin'

Vue.use(Router)

const mainRoutes = [
  {
    path: '/',
    partial: false,
    component: Index,
    name: 'Index',
  },
  {
    path: '/shift/:year/:month/',
    partial: false,
    component: ShiftIndex,
    props: true,
    name: 'ShiftIndex',
  },
  {
    path: '/shift-summary/:year/:month/',
    partial: false,
    component: ShiftSummary,
    props: true,
    name: 'ShiftSummary',
  },
  {
    path: '/shift-plan/:year/:month/',
    partial: false,
    component: ShiftPlanIndex,
    props: true,
    name: 'ShiftPlanIndex',
  },
]

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { noAuth: true },
    },
    {
      path: '/reservations/:shopId/:date/',
      partial: false,
      component: Dashboard,
      name: 'Dashboard',
      props: true,
    },
    {
      path: '/admin/',
      partial: false,
      component: AdminLayout,
      children: adminRoutes,
      meta: {
        requireAdmin: true,
      },
    },
    {
      path: '/',
      partial: false,
      component: MainLayout,
      children: mainRoutes,
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
      meta: { noAuth: true },
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js